module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/about.json
// module chunks = 17953591736895156000